module.exports = __webpack_public_path__ + "static/media/cd.2f7cdf4a.webp";